import { cloneDeep } from "lodash";
import moment from "moment";
import PondGuardService from "@/services/PondGuardService";
import ResourceManagementService from "@/services/ResourceManagementService";
import ShrimpGrowthService from "@/services/ShrimpGrowthService";
import ShrimpTalkService from "@/services/ShrimpTalkService";
import WaterQualityService from "@/services/WaterQualityService";
import {
  MOMENT_DATE_FORMAT_WITH_YEAR,
  castISOStringToUserTZ,
  IQRUpperBound,
  Quartile_50,
} from "@/utils/commonUtils";
const dateFormat = function(isoDateString) {
  return moment.utc(isoDateString).format(MOMENT_DATE_FORMAT_WITH_YEAR);
};
const initLatestABWValue = {
  abw: undefined,
  survival_percentage: 100,
  awg: undefined,
  total_dispensed_feed: undefined,
};
export default {
  namespaced: true,
  state: {
    pondList: [],
    selectedPondId: null,
    selectedPondWithDeviceDetails: {},
    pondIdPondMap: {},
    currentCulture: {},
    arrSelectedPondABWRecords: [],
    manualFeedData: [],
    slotWiseFeed: [],
    pondHourlyFeed: [],
    stHourlyFeed: [],
    stResponseGraphData: [],
    stOCFGraphData: [],
    pmSlotWiseFeed: [],
    pmDetailsOfSelectedPondId: [],
    stDetailsOfSelectedPondId: [],
    selectedTabName: "",
    arrSelectedPondPGs: [],
    latestAbwValue: { ...initLatestABWValue },
    feedConsumptionData: [],
    pondAbwVsBiomassGraphData: [],
    selectedPondMedcnsMinrls: [],
    allpondsMedicineMinerals: [],
    allpondsLabTests: [],
  },
  getters: {
    getSelectedpondAbwVsBiomassGraphData: (state) => {
      return state.pondAbwVsBiomassGraphData;
    },
    getAllPondsMedcnsMirls: (state) => {
      return state.allpondsMedicineMinerals;
    },
    getSelectedPondMedcnsMinrls: function(state) {
      return state.selectedPondMedcnsMinrls;
    },
    getStResponseGraphData: function(state) {
      return state.stResponseGraphData.map((x) => {
        x.data.shrimp_talk_code = x.shrimp_talk_code;
        x.data._id = x._id;
        return x.data;
      });
    },
    getStOCFGraphData: function(state) {
      return state.stOCFGraphData.map((x) => {
        x.data.shrimp_talk_code = x.shrimp_talk_code;
        x.data._id = x._id;
        return x.data;
      });
    },
    getSelectedPondLabTests: function(state) {
      return state.allpondsLabTests;
    },
    getSelectedPondAbwSummary: (state, getters) => {
      const {
        abw,
        awg,
        survival_percentage,
        total_dispensed_feed,
      } = state.latestAbwValue;
      const plStocked = getters.getCurrentCulturePLStocked;
      const biomass =
        abw && survival_percentage && plStocked
          ? (((abw / 1000) * survival_percentage) / 100) * plStocked
          : undefined;
      return {
        abw,
        awg,
        biomass,
        survival_percentage,
        total_dispensed_feed,
      };
    },
    getSelectedNetFeedSummary: (state) => {
      return state.feedConsumptionData;
    },
    getSelectedPondId: (state) => {
      return state.selectedPondId;
    },
    getSelectedPondName: (state, getters) => {
      return getters.getPondIdPondMap[getters.getSelectedPondId].title;
    },
    getArrSelectedPondABWRecords: (state, getters) => {
      return state.arrSelectedPondABWRecords;
    },
    getUserCountryName: (state, getters, rootState, rootGetters) => {
      return rootGetters["user/getUserCountryName"];
    },
    getUserTimeZone: (state, getters, rootState, rootGetters) => {
      return rootGetters["user/getUserTimeZone"];
    },
    getUserTimeZoneOffset: (state, getters, rootState, rootGetters) => {
      return rootGetters["user/getUserTimeZoneOffset"];
    },
    getPondIdPondMap: (state, getters, rootState, rootGetters) => {
      return rootGetters["pond/getPondsObj"];
    },
    getSelectedPondWithDeviceDetails: (state, getters) => {
      return state.selectedPondWithDeviceDetails;
    },
    getCultureName(state, getters) {
      return (getters.getCurrentCulture || { name: "NO_CURRENT_NAME" }).name;
    },
    getCurrentCulturePLStocked(state, getters) {
      return (
        getters.getCurrentCulture || { post_larva_stocked: "NO_PL_STOCKED" }
      ).post_larva_stocked;
    },
    getCurrentCulture(state, getters, rootState, rootGetters) {
      let currentCulture = cloneDeep(state.currentCulture || {});
      if (Object.keys(currentCulture).length > 0) return currentCulture;
      currentCulture = getters.getRunningCultureForSelectedPond;
      if (getters.getRunningCultureForSelectedPond) return currentCulture;
      const prevCultures = getters.getArrPrevCulturesForSelectedPond;
      if (prevCultures.length > 0) {
        currentCulture = prevCultures.reverse()[0];
        return currentCulture;
      }
      return {};
    },
    getAllCultureOfPond(state, getters) {
      const allCultures = getters.getArrPrevCulturesForSelectedPond;
      const runningCulture = getters.getRunningCultureForSelectedPond;
      if (runningCulture) {
        allCultures.push(runningCulture);
      }
      return allCultures;
    },
    getRunningCultureForSelectedPond(state, getters, rootState, rootGetters) {
      const pondId = getters.getSelectedPondId;
      const pond = getters.getPondIdPondMap[pondId];
      const userTimeZoneOffset = rootGetters["user/getUserTimeZoneOffset"];
      let currentCulture = null;
      if (pond && pond.cultivation_date && pond.cultivation_date !== "") {
        currentCulture = {
          start_date: pond.cultivation_date,
          post_larva_stocked: pond.post_larva_stocked,
          end_date:
            moment()
              .utcOffset(userTimeZoneOffset)
              .endOf("hours")
              .format("YYYY-MM-DDTHH:mm:ss.000") + "Z",
          harvest_id: 0,
          start_date_string: `${dateFormat(pond.cultivation_date)}`,
          name: `${dateFormat(pond.cultivation_date)}`,
        };
        currentCulture.is_running = true;
        currentCulture.doc = moment
          .utc(currentCulture.end_date)
          .diff(moment.utc(currentCulture.start_date), "days");
        return currentCulture;
      }
      return {};
    },
    getArrPrevCulturesForSelectedPond(state, getters) {
      const pondId = getters.getSelectedPondId;
      if (!pondId) return [];
      const pond = getters.getPondIdPondMap[pondId] || {};
      const cultivationsArr = cloneDeep(pond.cultivations || []);
      cultivationsArr.forEach((culture) => {
        const start_date = culture.start_date;
        const end_date = culture.end_date;
        culture.is_running = false;
        culture.name = `${dateFormat(start_date)} - ${dateFormat(end_date)}`;
        culture.start_date_string = `${dateFormat(start_date)}`;
        culture.doc = moment.utc(end_date).diff(moment.utc(start_date), "days");
      });
      return cultivationsArr;
    },
    getPondScheduleGraphSlotWiseFeed(state) {
      return state.slotWiseFeed;
    },
    getPondHourlyFeedGraph(state) {
      return state.pondHourlyFeed;
    },
    getStHourlyFeedGraph(state) {
      return state.stHourlyFeed;
    },
    getPmSlotWiseFeedGraph(state) {
      return state.pmSlotWiseFeed;
    },
    getPmIdPmDetailsOfSelectedPondId(state) {
      const pmIdPmDetails = {};
      state.pmDetailsOfSelectedPondId.forEach((pm) => {
        pmIdPmDetails[pm._id] = pm;
      });
      return pmIdPmDetails;
    },
    getStIdStDetailsOfSelectedPondId(state) {
      const stIdStDetails = {};
      state.stDetailsOfSelectedPondId.forEach((st) => {
        stIdStDetails[st._id] = st;
      });
      return stIdStDetails;
    },
    getManualFeedData(state) {
      return state.manualFeedData;
    },
    getABWData(state) {
      return state.arrABWRecs;
    },
    getArrSelectedPondPGs: function(state) {
      const objSelectedPondPGs = state.arrSelectedPondPGs.reduce(
        (acc, curr) => {
          acc[curr.device_id] = curr;
          return acc;
        },
        {}
      );
      return Object.values(objSelectedPondPGs);
    },
    getSTGraphOCFHourlyData(state, getters) {
      return getters.getStOCFGraphData.reduce(
        (acc, { one_cycle_feed: ocf, start }) => {
          const isoString = castISOStringToUserTZ(
            start,
            getters.getUserTimeZoneOffset
          );
          const correctDate = moment(isoString).startOf("hour");
          const timeEpoch = correctDate.valueOf();
          if (acc[timeEpoch] === undefined) {
            acc[timeEpoch] = 0;
          }
          acc[timeEpoch] += ocf;
          return acc;
        },
        {}
      );
    },
    getSTGraphHourlyFGData(state, getters) {
      return getters.getStOCFGraphData.reduce((acc, { feed_gap, start }) => {
        const isoString = castISOStringToUserTZ(
          start,
          getters.getUserTimeZoneOffset
        );
        const correctDate = moment(isoString).startOf("hour");
        const timeEpoch = correctDate.valueOf();
        if (acc[timeEpoch] === undefined) {
          acc[timeEpoch] = 0;
        }
        acc[timeEpoch] = feed_gap;
        return acc;
      }, {});
    },
    getSTGraphHourlyIntakeResponseData(state, getters) {
      const roundOff = (value) => +value.toFixed(1);
      const arrValuesST = getters.getStResponseGraphData;
      const arrUtilizationValues = arrValuesST.map((x) =>
        roundOff(x.utilization)
      );
      const IQRUpperBoundValue = IQRUpperBound(arrUtilizationValues);
      const IQRMedianValue = Math.round(Quartile_50(arrUtilizationValues));
      const response = arrValuesST.reduce(
        (acc, { utilization, one_cycle_feed: ocf, start, result }) => {
          const isoString = castISOStringToUserTZ(
            start,
            getters.getUserTimeZoneOffset
          );
          const correctDate = moment(isoString).startOf("hour");
          const timeEpoch = correctDate.valueOf();
          const isNoise = result === 3;
          const eachAvgIntakeResponse = Math.round(IQRMedianValue * ocf);
          const eachIntakeResponse = Math.round(roundOff(utilization) * ocf);
          if (acc.total[timeEpoch] === undefined) {
            acc.total[timeEpoch] = 0;
            // acc.group[timeEpoch] = [];
          }
          if (utilization > IQRUpperBoundValue || isNoise) {
            acc.total[timeEpoch] += eachAvgIntakeResponse;
            // acc.group[timeEpoch].push(eachAvgIntakeResponse);
          } else {
            acc.total[timeEpoch] += eachIntakeResponse;
            // acc.group[timeEpoch].push(eachIntakeResponse);
          }
          return acc;
        },
        { total: {} }
      );
      // console.log(response);
      return response.total;
    },
    getSTGraphValidResponseCnt: function(state, getters) {
      return getters.getStResponseGraphData.filter(
        (x) => x.result === 1 || x.result === 2
      ).length;
    },
    getSTGraphCyclesCnt: function(state, getters) {
      return getters.getStResponseGraphData.length;
    },
  },
  mutations: {
    SET_ABW_VS_BIOMASS_GRAPH_DATA: function(state, pondAbwVsBiomassGraphData) {
      state.pondAbwVsBiomassGraphData = pondAbwVsBiomassGraphData;
    },

    SET_SELECTED_NET_FEED_SUMMARY: function(state, feedConsumptionData) {
      state.feedConsumptionData = feedConsumptionData;
    },
    SET_SELECTED_POND_ABW_SUMMARY: function(state, latestAbwValue) {
      state.latestAbwValue = latestAbwValue || {
        ...initLatestABWValue,
      };
    },
    SET_POND_ID_POND_MAP: function(state, pondObj) {
      state.pondIdPondMap = pondObj;
    },
    SET_SELECTED_POND_ID: function(state, selectedPondId) {
      state.selectedPondId = selectedPondId;
    },
    SET_CURRENT_CULTURE: function(state, cultureObj) {
      state.currentCulture = Object.assign(
        {},
        state.currentCulture,
        cultureObj
      );
      // state.currentCulture = cultureObj;
    },
    SET_POND_SLOT_WISE_FEED: function(state, slotWiseLogs) {
      state.slotWiseFeed = slotWiseLogs;
    },
    SET_SELECTED_POND_WITH_DEVICE_DETAILS: function(
      state,
      selectedPondWithDeviceDetails
    ) {
      state.selectedPondWithDeviceDetails = selectedPondWithDeviceDetails;
    },
    SET_POND_HOURLY_WISE_FEED: function(state, hourlyFeedLogs) {
      state.pondHourlyFeed = hourlyFeedLogs;
    },
    SET_ST_HOURLY_WISE_FEED: function(state, hourlyFeedLogs) {
      state.stHourlyFeed = hourlyFeedLogs;
    },
    SET_PM_SLOT_WISE_FEED: function(state, slotWiseFeedLogs) {
      state.pmSlotWiseFeed = slotWiseFeedLogs;
    },
    SET_PM_DETAILS_OF_POND: function(state, pmsDetails) {
      state.pmDetailsOfSelectedPondId = pmsDetails;
    },
    SET_ST_DETAILS_OF_POND: function(state, stsDetails) {
      state.stDetailsOfSelectedPondId = stsDetails;
    },
    SET_POND_MANUAL_FEED: function(state, manualFeedData) {
      state.manualFeedData = manualFeedData;
    },
    SET_SELECTED_POND_ABW_RECORDS: function(state, arrABWRecs) {
      state.arrSelectedPondABWRecords = arrABWRecs;
    },
    SET_SELECTED_TAB: function(state, selectedTabName) {
      state.selectedTabName = selectedTabName;
    },
    SET_SELECTED_POND_PGS: function(state, listOfPondGuards) {
      state.arrSelectedPondPGs = listOfPondGuards;
    },
    SET_SELECTED_POND_MEDICINE_MINERALS: function(
      state,
      pondsMedicineMinerals
    ) {
      state.selectedPondMedcnsMinrls = pondsMedicineMinerals;
    },
    SET_POND_MEDICINE_MINERALS: function(state, allpondsMedicineMinerals) {
      state.allpondsMedicineMinerals = allpondsMedicineMinerals;
    },
    SET_ST_RESP_GRAPH_DATA: function(state, statsData) {
      state.stResponseGraphData = statsData;
    },
    SET_ST_OCF_GRAPH_DATA: function(state, statsData) {
      state.stOCFGraphData = statsData;
    },
    SET_SELECTED_POND_LAB_TESTS: function(state, allpondsLabTests) {
      state.allpondsLabTests = allpondsLabTests;
    },
  },
  actions: {
    fetchAPondDetails: async function(context, selectedPondId) {
      if (selectedPondId !== "") {
        const pondDetails = await context.dispatch(
          "pond/fetchAPond",
          selectedPondId,
          {
            root: true,
          }
        );
        const pms = await context.dispatch(
          "pondmother/fetchPondMothersOnPondId",
          selectedPondId,
          { root: true }
        );
        const sts = await context.dispatch(
          "shrimptalk/fetchShrimpTalksOnPondId",
          { pondId: selectedPondId },
          { root: true }
        );
        context.commit("SET_PM_DETAILS_OF_POND", pms);
        context.commit("SET_ST_DETAILS_OF_POND", sts);
        context.commit("SET_SELECTED_POND_WITH_DEVICE_DETAILS", pondDetails);
      }
    },
    fetchStDetailsByPondId: async function(context, { pondId, params }) {},
    fetchPondPGsInCurrCulture: async function(context, { pondId, params }) {
      const response = await PondGuardService.fetchPGsUsedInCurrCulture(
        pondId,
        { get_all: true, ...params }
      );
      context.commit("SET_SELECTED_POND_PGS", response.data.pond_guards);
    },
    fetchSelectedPondLatestNABWValue: async function(
      context,
      { pondId, params }
    ) {
      const response = await ShrimpGrowthService.fetchSelectedPondLatestNABWValue(
        pondId,
        params
      );
      return response.data;
    },
    fetchFeedConsumptionSummary: async function(context, { pondId, params }) {
      const response = await ShrimpGrowthService.fetchFeedConsumptionSummary(
        pondId,
        params
      );
      return response.data;
    },
    fetchPondGuardData: async function(context, { pondId, pgId, params }) {
      const response = await WaterQualityService.fetchAllParamsOfWaterQuality(
        pondId,
        pgId,
        params
      );
      return response.data;
    },
    fetchAquaLabPondGuardData: async function(context, { pgId, params }) {
      const response = await WaterQualityService.fetchAquaLabAllParamsOfWaterQuality(
        pgId,
        params
      );
      return response.data;
    },
    changeSelectedPondId: async function(context, selectedPondId) {
      await context.dispatch("fetchAPondDetails", selectedPondId);
      context.commit("SET_SELECTED_POND_ID", selectedPondId);
      let currentCulture = context.getters.getRunningCultureForSelectedPond;
      const prevCultures = context.getters.getArrPrevCulturesForSelectedPond;
      if (
        Object.keys(currentCulture || {}).length === 0 &&
        prevCultures.length > 0
      ) {
        currentCulture = prevCultures.reverse()[0];
      }

      context.dispatch("changeCulture", currentCulture);
      // end,start
      // call the remaining api abw,feed consumptions summary
      await Promise.all([
        context.dispatch("latestAbwValues"),
        context.dispatch("feedConsumptionData"),
      ]);
    },
    pondAbwVsBiomassGraphData: async function(context) {
      const pondId = context.getters.getSelectedPondId;
      const currentCulture = context.getters.getCurrentCulture;
      const abwbiomassgraphqwery = {
        cultivation_start_date: currentCulture.start_date,
      };
      const response = await ShrimpGrowthService.fetchAbwVsBiomassGraphData(
        pondId,
        abwbiomassgraphqwery
      );
      context.commit("SET_ABW_VS_BIOMASS_GRAPH_DATA", response.data.data);
    },
    latestAbwValues: async function(context) {
      const pondId = context.getters.getSelectedPondId;
      const abwquery = {
        no_of_records: 1,
      };
      const response = await ShrimpGrowthService.fetchSelectedPondLatestNABWValue(
        pondId,
        abwquery
      );
      context.commit(
        "SET_SELECTED_POND_ABW_SUMMARY",
        response.data.pond.latest_records[0]
      );
    },
    feedConsumptionData: async function(context) {
      const pondId = context.getters.getSelectedPondId;
      const currentCulture = context.getters.getCurrentCulture;
      const query = {
        from_date: currentCulture.start_date,
        to_date: currentCulture.end_date,
      };
      const response = await ShrimpGrowthService.fetchFeedConsumptionSummary(
        pondId,
        query
      );
      context.commit("SET_SELECTED_NET_FEED_SUMMARY", response.data.data);
    },
    changeCulture: function(context, cultureObj) {
      context.commit("SET_CURRENT_CULTURE", cultureObj);
    },
    fetchAllPondDetails: async function(context) {
      await context.dispatch("pond/fetchAllPonds");
      context.commit(
        "SET_POND_ID_POND_MAP",
        context.rootGetters["pond/pondsObj"]
      );
    },
    fetchSlotWiseFeed: async function(context, { deviceType, params }) {
      const pondId = context.getters.getSelectedPondId;
      if (pondId !== undefined) {
        const response = await context.dispatch(
          "pond/fetchSlotWisePondFeed",
          { pondId, params: { ...params } },
          { root: true }
        );
        if (deviceType === "pond") {
          context.commit(
            "SET_POND_SLOT_WISE_FEED",
            response.pond_slotwise_feed_logs
          );
        } else if (deviceType === "pond_mother") {
          context.commit(
            "SET_PM_SLOT_WISE_FEED",
            response.pond_slotwise_feed_logs
          );
        }
      }
    },
    fetchHourWisePondFeed: async function(context, { deviceType, params }) {
      const pondId = context.getters.getSelectedPondId;
      if (pondId !== undefined) {
        const response = await context.dispatch(
          "pond/fetchHourWisePondFeed",
          { pondId, params: { ...params } },
          { root: true }
        );
        if (deviceType === "pond") {
          context.commit(
            "SET_POND_HOURLY_WISE_FEED",
            response.pond_hourly_feed_logs
          );
        } else if (deviceType === "shrimp_talk") {
          context.commit(
            "SET_ST_HOURLY_WISE_FEED",
            response.pond_hourly_feed_logs
          );
        }
      }
    },
    changePondWithDeviceDetails: async function(
      context,
      pondWithDeviceDetails
    ) {
      context.commit(
        "SET_SELECTED_POND_WITH_DEVICE_DETAILS",
        pondWithDeviceDetails
      );
    },
    fetchManualFeedData: async function(context, { deviceType, params }) {
      const pondId = context.getters.getSelectedPondId;
      if (pondId !== undefined) {
        const response = await context.dispatch(
          "pond/fetchManualFeedDataBasedOnPondId",
          { pondId, params: { ...params } },
          { root: true }
        );
        context.commit("SET_POND_MANUAL_FEED", response);
      }
    },
    fetchStStatsData: async function(context, { stId, params, graph }) {
      const graphToSetterMap = {
        ST_HOURLY: "SET_ST_RESP_GRAPH_DATA",
        ST_OCF: "SET_ST_OCF_GRAPH_DATA",
      };
      const pondId = context.getters.getSelectedPondId;
      if (pondId === undefined) return;
      const response = await ShrimpTalkService.fetchStStatsByPondIdAndStId(
        pondId,
        stId,
        params
      );
      context.commit(graphToSetterMap[graph], response.data.data);
    },
    fetchPondABWValues: async function(context, params) {
      const pondId = context.getters.getSelectedPondId;
      if (pondId !== undefined) {
        const arrABWRecs = await context.dispatch(
          "pond/fetchPondABWValues",
          { pondId, ...params },
          { root: true }
        );
        context.commit("SET_SELECTED_POND_ABW_RECORDS", arrABWRecs);
      }
    },
    changeSelectedTab: async function(context, tabName) {
      context.commit("SET_SELECTED_TAB", tabName);
    },
    deleteABWRecord: async function(context, abwId) {
      await context.dispatch("pond/deleteABWRecord", abwId, { root: true });
    },
    fetchResourcesByPondId: async function(context, params = {}) {
      const pondId = context.getters.getSelectedPondId;
      const currentCulture = context.getters.getCurrentCulture;

      const query = {
        from_date: currentCulture.start_date,
        to_date: currentCulture.end_date,
      };

      params.from_date = query.from_date;
      params.to_date = query.to_date;

      const response = await ResourceManagementService.fetchResourcesByPondId(
        pondId,
        params
      );
      context.commit(
        "SET_SELECTED_POND_MEDICINE_MINERALS",
        response.data.ponds_medicines_and_mineral_entries
      );
    },
    fetchLabTestsByPondId: async function(context, params = {}) {
      const pondId = context.getters.getSelectedPondId;
      const currentCulture = context.getters.getCurrentCulture;

      const query = {
        from_date: currentCulture.start_date,
        to_date: currentCulture.end_date,
      };

      params.from_date = query.from_date;
      params.to_date = query.to_date;

      const response = await ResourceManagementService.fetchLabTests(
        pondId,
        params
      );

      context.commit("SET_SELECTED_POND_LAB_TESTS", response.data.data);
    },
    fetchResourcesOfAllPonds: async function(context) {
      const response = await ResourceManagementService.fetchAllResources();
      context.commit(
        "SET_POND_MEDICINE_MINERALS",
        response.data.ponds_medicines_and_mineral_entries
      );
    },
  },
};
